import { Module, VuexModule, Action, Mutation } from 'vuex-module-decorators';
import { CollectionProxy } from 'spraypaint/lib-esm/proxies';
import ObservedPromise from 'spa-ionata-admin/lib/services/ObservedPromise';
import ExportMarket from '../models/ExportMarket';

@Module({
  name: 'ExportMarketsModule',
  namespaced: true,
})
export default class ExportMarketsModule extends VuexModule {
  itemsPromise = new ObservedPromise<CollectionProxy<ExportMarket>>();

  get items(): ExportMarket[] {
    return this.itemsPromise.value?.data.filter(item => item.visible) || [];
  }

  get isLoading() {
    return this.itemsPromise.isPending;
  }

  get error() {
    return this.itemsPromise.error;
  }

  // Bloody vuex-module-decorators crap
  get find() {
    return (id: string): ExportMarket | undefined => {
      if (!id) {
        return undefined;
      }
      return this.items.find(item => item.id === id);
    };
  }

  @Mutation
  fetchItems() {
    // const promise = ExportMarket.where({ visible: true }).all();
    const promise = ExportMarket.all();
    this.itemsPromise = new ObservedPromise(promise);
  }

  @Action
  async fetchItemsIfNeeded() {
    const { isPending, value } = this.itemsPromise;
    if (value != null) {
      return;
    }
    try {
      if (!isPending) {
        this.context.commit('fetchItems');
      }
      await this.itemsPromise.promise;
    } catch {
      // check this.error
    }
  }
}
